import classNames from 'classnames';

import styles from './index.module.scss';

export type BackgroundProps = {
  src: string;
  type?: 'white' | null;
  children: React.ReactNode;
};

export const Background: React.FC<BackgroundProps> = ({
  src,
  type,
  children,
}) => {
  if (!src) {
    return <>{children}</>;
  }

  return (
    <div
      className={classNames(styles.background, {
        [styles.white]: type === 'white',
      })}
      style={{
        backgroundImage: `url(${src})`,
      }}
    >
      {children}
    </div>
  );
};
